import { CompositeLayer, CompositeLayerProps, Layer, LayerContext, LayersList, UpdateParameters } from "@deck.gl/core";
import { BitmapTileLayer, BitmapTileLayerProps } from "react-migration/lib/map/layers/BitmapTileLayer";

export type RasterLayerProps = CompositeLayerProps & {
  url: BitmapTileLayerProps["data"];
  underZoomLevel: number;
  hideZoomLevel: number;
};

export class RasterWithUnderZoom extends CompositeLayer<RasterLayerProps> {
  private emptyLayer: Layer;
  private standardLayer: Layer;

  get zoom() {
    return Math.round(this.context.viewport.zoom);
  }

  constructor(props: RasterLayerProps) {
    super(props);

    this.emptyLayer = new BitmapTileLayer({ data: null, id: `${props.id}-raster_empty` });
    this.standardLayer = new BitmapTileLayer({
      data: props.url,
      refinementStrategy: "no-overlap",
      minZoom: props.underZoomLevel,
      extent: [-180.0, -90.0, 180.0, 90.0],
      id: `${props.id}-raster_standard`,
    });
  }

  renderLayers(): Layer | null | LayersList {
    const zoom = this.zoom;

    if (zoom < this.props.hideZoomLevel) {
      return this.emptyLayer;
    }

    return this.standardLayer;
  }

  initializeState(context: LayerContext) {
    super.initializeState(context);

    this.setState({
      zoom: this.zoom,
    });
  }

  shouldUpdateState({ changeFlags }: UpdateParameters<this>) {
    const newZoomLevel = this.zoom;

    if (newZoomLevel !== this.state.googleZoomLevel) {
      this.setState({ googleZoomLevel: newZoomLevel });
      return true;
    }

    return changeFlags.propsOrDataChanged;
  }
}
